import { z } from "zod";

const predictionSubCategorySchema = z.object({
  name: z.string(),
  full_name: z.string(),
  display_name: z.string(),
  default: z.boolean().catch(false),
});

const predictionCategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  default: z.boolean().catch(false),
  subcategories: z.array(predictionSubCategorySchema).catch([]),
});

type PredictionSubCategory = z.infer<typeof predictionSubCategorySchema>;
type PredictionCategory = z.infer<typeof predictionCategorySchema>;

export {
  predictionCategorySchema,
  predictionSubCategorySchema,
  type PredictionCategory,
  type PredictionSubCategory,
};
